/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

export class OrganisationModel {
  private _organisationId: string;
  private _organisationName: string;
  private _organisationOwner: string;
  private _organisationBuilding: string;
  private _organisationStreet: string;
  private _organisationTown: string;
  private _organisationCounty: string;
  private _organisationPostcode: string;
  private _countryId: string;
  private _parentId?: string;
  private _organisationStandAlone: boolean;
  private _organisationShortname: string;
  private _organisationApproved: boolean;
  private _packageId: number;
  private _paymentStatus: string;
  private _organisationLogo: string;
  private _organisationCSS: string;
  private _createdAt: number;
  private _updatedAt: Date;
  private _organisationStrapline: string;
  private _platformLogo: string;

  constructor(
    organisationId?: string,
    organisationName?: string,
    organisationOwner?: string,
    organisationBuilding?: string,
    organisationStreet?: string,
    organisationTown?: string,
    organisationCounty?: string,
    organisationPostcode?: string,
    countryId?: string,
    parentId?: string,
    organisationStandAlone?: boolean,
    organisationShortname?: string,
    organisationApproved?: boolean,
    packageId?: number,
    paymentStatus?: string,
    organisationLogo?: string,
    organisationCSS?: string,
    createdAt?: number,
    updatedAt?: Date,
    organisationStrapline?: string,
    platformLogo?: string
  ) {
    this._organisationId = organisationId;
    this._organisationName = organisationName;
    this._organisationOwner = organisationOwner;
    this._organisationBuilding = organisationBuilding;
    this._organisationStreet = organisationStreet;
    this._organisationTown = organisationTown;
    this._organisationCounty = organisationCounty;
    this._organisationPostcode = organisationPostcode;
    this._countryId = countryId;
    this._parentId = parentId;
    this._organisationStandAlone = organisationStandAlone;
    this._organisationShortname = organisationShortname;
    this._organisationApproved = organisationApproved;
    this._packageId = packageId;
    this._paymentStatus = paymentStatus;
    this._organisationLogo = organisationLogo;
    this._organisationCSS = organisationCSS;
    this._createdAt = createdAt;
    this._updatedAt = updatedAt;
    this._organisationStrapline = organisationStrapline;
    this._platformLogo = platformLogo;
  }

  get organisationId(): string {
    return this._organisationId;
  }

  set organisationId(value: string) {
    this._organisationId = value;
  }

  get organisationName(): string {
    return this._organisationName;
  }

  set organisationName(value: string) {
    this._organisationName = value;
  }

  get organisationOwner(): string {
    return this._organisationOwner;
  }

  set organisationOwner(value: string) {
    this._organisationOwner = value;
  }

  get organisationBuilding(): string {
    return this._organisationBuilding;
  }

  set organisationBuilding(value: string) {
    this._organisationBuilding = value;
  }

  get organisationStreet(): string {
    return this._organisationStreet;
  }

  set organisationStreet(value: string) {
    this._organisationStreet = value;
  }

  get organisationTown(): string {
    return this._organisationTown;
  }

  set organisationTown(value: string) {
    this._organisationTown = value;
  }

  get organisationCounty(): string {
    return this._organisationCounty;
  }

  set organisationCounty(value: string) {
    this._organisationCounty = value;
  }

  get organisationPostcode(): string {
    return this._organisationPostcode;
  }

  set organisationPostcode(value: string) {
    this._organisationPostcode = value;
  }

  get countryId(): string {
    return this._countryId;
  }

  set countryId(value: string) {
    this._countryId = value;
  }

  get parentId(): string {
    return this._parentId;
  }

  set parentId(value: string) {
    this._parentId = value;
  }

  get organisationStandAlone(): boolean {
    return this._organisationStandAlone;
  }

  set organisationStandAlone(value: boolean) {
    this._organisationStandAlone = value;
  }

  get organisationShortname(): string {
    return this._organisationShortname;
  }

  set organisationShortname(value: string) {
    this._organisationShortname = value;
  }

  get organisationApproved(): boolean {
    return this._organisationApproved;
  }

  set organisationApproved(value: boolean) {
    this._organisationApproved = value;
  }

  get packageId(): number {
    return this._packageId;
  }

  set packageId(value: number) {
    this._packageId = value;
  }

  get paymentStatus(): string {
    return this._paymentStatus;
  }

  set paymentStatus(value: string) {
    this._paymentStatus = value;
  }

  get organisationLogo(): string {
    return this._organisationLogo;
  }

  set organisationLogo(value: string) {
    this._organisationLogo = value;
  }

  get platformLogo(): string {
    return this._platformLogo;
  }

  set platformLogo(value: string) {
    this._platformLogo = value;
  }

  get organisationCSS(): string {
    return this._organisationCSS;
  }

  set organisationCSS(value: string) {
    this._organisationCSS = value;
  }

  get createdAt(): number {
    return this._createdAt;
  }

  set createdAt(value: number) {
    this._createdAt = value;
  }

  get updatedAt(): Date {
    return this._updatedAt;
  }

  set updatedAt(value: Date) {
    this._updatedAt = value;
  }

  get organisationStrapline(): string {
    return this._organisationStrapline;
  }

  set organisationStrapline(value: string) {
    this._organisationStrapline = value;
  }

  toJson(): Object {
    const object = {
      organisation_id: this.organisationId,
      organisation_name: this.organisationName,
      organisation_owner: this.organisationOwner,
      organisation_building: this.organisationBuilding,
      organisation_street: this.organisationStreet,
      organisation_town: this.organisationTown,
      organisation_county: this.organisationCounty,
      organisation_postcode: this.organisationPostcode,
      country_id: this.countryId,
      parent_id: this.parentId,
      organisation_stand_alone: this.organisationStandAlone,
      organisation_shortname: this.organisationShortname,
      organisation_approved: this.organisationApproved,
      package_id: this.packageId,
      payment_status: this.paymentStatus,
      organisation_logo: this.organisationLogo,
      organisation_css: this.organisationCSS,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      organisation_strapline: this.organisationStrapline,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): OrganisationModel {
    return new OrganisationModel(
      input['organisation_id'],
      input['organisation_name'],
      input['organisation_owner'],
      input['organisation_building'],
      input['organisation_street'],
      input['organisation_town'],
      input['organisation_county'],
      input['organisation_postcode'],
      input['country_id'],
      input['parent_id'],
      input['organisation_stand_alone'],
      input['organisation_shortname'],
      input['organisation_approved'],
      input['package_id'],
      input['payment_status'],
      input['organisation_logo'],
      input['organisation_css'],
      input['created_at'],
      input['updated_at'],
      input['organisation_strapline'],
      input['platform_logo']
    );
  }
}
